import { SHIPPO_DE_ADDRESS, SHIPPO_US_ADDRESS } from '~/constants/shippo-addresses';
import { InjectedTranslateProps, translate } from '~/utils/translate';

interface OwnProps {
  isGerman: boolean;
}

const ShippoInvoiceAddress = (props: OwnProps & InjectedTranslateProps) => {
  const { isGerman, t } = props;
  const shippoAddress = isGerman ? SHIPPO_DE_ADDRESS : SHIPPO_US_ADDRESS;

  return (
    <>
      <strong>{shippoAddress.company}</strong>
      <br />
      {shippoAddress.street1}
      <br />
      {shippoAddress.street2 && (
        <>
          {shippoAddress.street2}
          <br />
        </>
      )}
      {isGerman ? (
        <>
          {shippoAddress.zip} {shippoAddress.city}
          <br />
          {shippoAddress.country}
          <br />
          <i>{t('account.billing.invoices.download.vatDisclaimer')}</i>
        </>
      ) : (
        `${shippoAddress.city}, ${shippoAddress.state}, ${shippoAddress.zip}`
      )}
      <br />
      {shippoAddress.email}
    </>
  );
};

const ComposedShippoInvoiceAddress = translate('settings')(ShippoInvoiceAddress);

export default ComposedShippoInvoiceAddress;
